module.exports = __webpack_public_path__ + "static/media/verizon.34fe5203.svg";